import { standardCheckoutRoutes, trialCheckoutRoutes } from "@jti/fe-common";
export const getPgsCallbackUrls = ({ orderId, paymentToken, isFreeTrial = false, }) => {
    const checkoutRoutes = isFreeTrial ? trialCheckoutRoutes : standardCheckoutRoutes;
    const { origin, pathname } = new URL(window.location.toString());
    const baseUrl = `${origin}${pathname}#`;
    const paymentSuccessfulUrl = `${baseUrl}${checkoutRoutes.payment.getSuccessPaymentUrl(orderId, paymentToken)}`;
    const paymentFailedUrl = `${baseUrl}${checkoutRoutes.payment.getFailedPaymentUrl(orderId)}`;
    return {
        paymentSuccessfulUrl,
        paymentFailedUrl,
    };
};
//# sourceMappingURL=getPgsCallbackUrls.js.map